import { defineStore } from "pinia";

import { snippetService } from "@/services";

import { useCaseStore } from "@/stores/case-store";
import { useBrandStore } from "@/stores/brand-store";

import { Snippet } from "@/models/Snippet";
import { ModuleStatus } from "@/models/ModuleStatus";

interface State {
  moduleStatus: ModuleStatus;
  entries: readonly Snippet[];
}
export const useSnippetStore = defineStore("snippet", {
  scope: "case",
  state: (): State => ({
    moduleStatus: ModuleStatus.Initial,
    entries: [],
  }),
  getters: {},
  actions: {
    async load(): Promise<void> {
      const brandStore = useBrandStore();
      if (brandStore.featuresConfig?.quarantine === "disabled") return;

      const selectedCaseName = useCaseStore().selectedCaseName;
      if (brandStore.selectedBrand == null || brandStore.selectedClient == null || selectedCaseName == null) return;

      if (this.moduleStatus !== ModuleStatus.Initial) return;

      try {
        const items: Snippet[] = await snippetService.getAll(
          brandStore.selectedClient,
          brandStore.selectedBrand,
          selectedCaseName,
        );
        this.snippetsLoaded(items);
      } finally {
        this.setStatus(ModuleStatus.Ready);
      }
    },

    setStatus(moduleStatus: ModuleStatus): void {
      this.moduleStatus = moduleStatus;
    },
    snippetsLoaded(payload: Snippet[]): void {
      this.entries = Object.freeze(payload);
    },
    reset(): void {
      this.moduleStatus = ModuleStatus.Initial;
      this.entries = [];
    },
  },
});
